<template>
  <v-container grid-list-md fluid>
    <v-layout
      align-center
      justify-center
      row
      v-show="!eventsLoaded"
      style="height: 300px;"
    >
      <v-flex shrink style="text-align: center;">
        <v-progress-circular
          indeterminate
          size="72"
        />
      </v-flex>
    </v-layout>
    <v-layout
      align-center
      justify-center
      row
      v-show="eventsLoaded && events.length === 0"
      style="height: 300px;"
    >
      <v-flex shrink style="text-align: center;">
        <h2>We're sorry!</h2>
        <p>Our season is over. We don't have any open events at this time.</p>
      </v-flex>
    </v-layout>
    <v-layout
      row
      wrap
      fill-height
      v-show="events.length > 0"
    >
      <v-flex
        xs12 md6 lg4 xl3
        v-for="event in events" :key="event.id"
      >
        <event-card :event="event" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import eventCard from '../components/EventCard'
export default {
  name: 'EventList',
  components: {
    eventCard
  },
  computed: {
    eventsLoaded () { return this.$store.state.eventsLoaded },
    events(){ return this.$store.state.events }
  }
}
</script>

<style>
h1, h2, h3, h4, h5 {
  font-family: "Motiva Sns W01 X Bd It",MotivaSans-ExtraBoldItalic,GillSans-BoldItalic,HelveticaNeue-BoldItalic,Helvetica-BoldOblique,Arial-BoldItalicMT,sans-serif
}

body .application, .body {
  font-family: "Motiva Sns W01 Regular",MotivaSans-Regular,GillSans,HelveticaNeue,Helvetica,Arial,sans-serif !important;
}
.v-alert {
  padding: .5rem 1rem;
}
</style>